import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

type ReadIntegrationOptionValuesV3 = OpalApi<
  'ReadIntegrationOptionValuesV3',
  200
>

export const readIntegrationOptionValues: ReadIntegrationOptionValuesV3 =
  async ({ params }: Parameters<ReadIntegrationOptionValuesV3>[0] = {}) => {
    const url = new URL('/v3/integration_option_values', window.location.origin)

    url.search = queryString(params?.query)

    return HttpClient()
      .get(url.toString())
      .then((res) => res.data)
  }
